'use client'; // Ensures this runs on the client side
import { useAnalytics } from '@/context/AnalyticsContext';

const useAnalyticsHook = () => {
    const analytics = useAnalytics();
    return analytics;
};

export default useAnalyticsHook;
